import {CrossFilledIcon, Trails} from '@gwc/main'
import clsx from 'clsx'

import {classes} from './classes'
import {ClearableTrailProps} from './types'

export const ClearableTrail = ({isVisible, onClear}: ClearableTrailProps) => (
  <Trails.Icon color="minor">
    <CrossFilledIcon className={clsx(classes.clearIcon, isVisible !== true && classes.hidden)} onPointerUp={onClear} />
  </Trails.Icon>
)
